import React from 'react';
import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { navigate, RouteComponentProps } from '@reach/router';
import { appDispatch, RootState } from 'store/store';
import { SpaceBetween } from 'utils/style/extendable';
import messages from './Messages';
import TemplatesList from './TemplatesList';
import { display } from 'components/ErrorView/ErrorDialog';
import Button from 'components/Button';
import ActionLink from 'components/ActionLink';
import notify from 'components/Notify';
import {
  IProviderTemplate,
  IProviderTemplates,
  saveProviderTemplate,
  saveProviderTemplateFn,
} from 'store/templates/templatesSlice';

interface IOwnProps {
  providerId?: string;
}

interface IStateToProps {
  templates: IProviderTemplates;
}

interface IDispatchToProps {
  saveProviderTemplate: (
    template: IProviderTemplate,
    isUpdate: boolean
  ) => ReturnType<typeof saveProviderTemplateFn>;
}

type IComponentProps = IOwnProps &
  IStateToProps &
  IDispatchToProps &
  RouteComponentProps;

interface IProviderTemplatesListState {
  showDeleted: boolean;
}

class ProviderTemplatesList extends React.Component<
  IComponentProps,
  IProviderTemplatesListState
> {
  state = {
    showDeleted: false,
  };

  openTemplateEditor = () => {
    navigate('templates/editor');
  };

  handleEditTemplate = (templateId: number) => () => {
    navigate(`templates/editor/${templateId}`);
  };

  handleDeleteTemplate =
    (templateId: number, isRestore: boolean = false) =>
    () => {
      const template: IProviderTemplate = this.props.templates.data[templateId];
      template.admins = template.admins
        ? Object.values(template.admins)
        : template.admins;
      template.deleted = !isRestore;
      this.props
        .saveProviderTemplate(template, true)
        .then(() => {
          if (
            !Object.values(this.props.templates.data).find(
              (t: IProviderTemplate) => t.deleted
            )
          ) {
            this.setState({ showDeleted: false });
          }
          notify(
            isRestore ? messages.templateRestored : messages.templateRemoved
          );
        })
        .catch((err: any) => {
          display(err);
        });
    };

  handleShowDeletedTemplates = () => {
    this.setState((prevState) => ({ showDeleted: !prevState.showDeleted }));
  };

  render() {
    const { templates } = this.props;
    const filteredTemplates = Object.values(templates.data).filter(
      (template) => template.deleted === this.state.showDeleted
    )[0] as IProviderTemplate;
    return (
      <div className="section">
        <SpaceBetween>
          <Button color="green" onClick={this.openTemplateEditor}>
            {messages.addNewTemplate}
          </Button>
          {Object.values(templates.data).find(
            (template: IProviderTemplate) => template.deleted
          ) && (
            <ActionLink color="blue" onClick={this.handleShowDeletedTemplates}>
              {this.state.showDeleted
                ? messages.hideDeletedTemplates
                : messages.showDeletedTemplates}
            </ActionLink>
          )}
        </SpaceBetween>
        <TemplatesList
          templates={filteredTemplates}
          onEditTemplate={this.handleEditTemplate}
          onDeleteTemplate={this.handleDeleteTemplate}
        />
      </div>
    );
  }
}

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state: RootState
) => {
  const templates = state.templates;

  return { templates };
};

const mapDispatchToProps: MapDispatchToProps<IDispatchToProps, IOwnProps> = {
  saveProviderTemplate: (template: IProviderTemplate, isUpdate: boolean) =>
    appDispatch(
      saveProviderTemplate({
        template,
        isUpdate,
      })
    ),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProviderTemplatesList);
